@if (formProperties.length > 0) {
  <app-dynamic-form
    [formProperties]="formProperties"
    [formGroup]="formGroup"
  ></app-dynamic-form>
}

@if (hasCustomFields) {
  <div class="use-case-inputs-step__custom-fields" [formGroup]="formGroup">
    @for (field of repeaterFields; track field.key) {
      <app-use-case-item-list
        [itemShape]="field.itemShape"
        [label]="field.label"
        [formControlName]="field.key"
      ></app-use-case-item-list>
    }
    @for (field of sourcePickerFields; track field.key) {
      <app-use-case-source-picker
        [label]="field.label"
        [nomenclature]="field.nomenclature"
        [formControlName]="field.key"
      ></app-use-case-source-picker>
    }
  </div>
}

@if (formProperties.length === 0 && !hasCustomFields) {
  <p class="use-case-inputs-step__empty">
    {{
      "use-case-wizard.inputs-step.status.no-fields-for-this-step" | translate
    }}
  </p>
}
